import { JDSBadgeV2BrandProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSBadgeV2BrandProps>
  ): React.FC<JDSBadgeV2BrandProps> =>
  (props: JDSBadgeV2BrandProps) => {
    return <Component {...props} />;
  };
